
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.719 3.281l2.313 2.313c.923-.39 1.922-.594 2.969-.594s2.046.203 2.969.594l2.313-2.313 1.438 1.438-1.938 1.938c1.462 1.119 2.61 2.755 3.344 4.656l2.438-1.219.875 1.813-2.75 1.375c.183.876.313 1.782.313 2.719 0 .34-.006.666-.031 1h3.031v2h-3.375c-.242 1.043-.561 2.039-1.031 2.938l3 2.25-1.188 1.625-2.938-2.188c-1.618 2.056-3.885 3.375-6.469 3.375s-4.851-1.319-6.469-3.375l-2.938 2.188-1.188-1.625 3-2.25c-.47-.898-.789-1.894-1.031-2.938H4.001v-2h3.031c-.025-.334-.031-.66-.031-1 0-.937.13-1.843.313-2.719l-2.75-1.375.875-1.813 2.438 1.219c.734-1.901 1.882-3.538 3.344-4.656L9.283 4.719zM16 7c-1.978 0-3.827 1.094-5.125 2.875C12.009 10.386 13.799 11 16 11s3.991-.614 5.125-1.125C19.827 8.094 17.978 7 16 7zm-6.094 4.594A10.93 10.93 0 009 16c0 4.629 2.698 8.282 6 8.906V12.937a14.623 14.623 0 01-5.094-1.344zm12.188 0A14.645 14.645 0 0117 12.938v11.969c3.302-.625 6-4.278 6-8.906 0-1.618-.337-3.115-.906-4.406z"}})])
          )
        }
      }
    